import { all, call, fork, put, select, takeEvery } from "redux-saga/effects";
import { GET } from "../../helpers/apiHelper";
import * as action from "./actions";

export const getListState = (state) => state.syncLogApp.list;

const loadSyncLogListAsync = async (query) => GET(`/sync-log?${query}`);

function* loadSyncLogList({ payload }) {
  try {
    const list = yield select(getListState);
    console.log('saga payload:', payload);
    let param = [
      {
        name: "page",
        value: payload.selectedPage,
      },
      {
        name: "limit",
        value: payload.limit,
      },
      {
        name: "orderby",
        value: list.orderBy,
      },
      {
        name: "sortedby",
        value: list.sortedBy,
      },
      {
        name: "deleteFlag",
        value: encodeURIComponent(payload.deleteFlag),
      },
    ];

    // Add date range filters if provided
    if (payload.startDate) {
      console.log('Adding startDate:', payload.startDate);
      param.push({
        name: "startDate",
        value: payload.startDate,
      });
    }

    if (payload.endDate) {
      console.log('Adding endDate:', payload.endDate);
      param.push({
        name: "endDate",
        value: payload.endDate,
      });
    }

    if (list.filter || "") {
      param = [
        ...param,
        ...[
          {
            name: "search",
            value: list.filter,
          },
        ],
      ];
    }
    const queryString = param.map((t) => `${t.name}=${t.value}`).join("&");
    console.log('Final query string:', queryString);
    const response = yield call(loadSyncLogListAsync, queryString);
    yield put(action.loadSyncLogListSuccess(response));
  } catch (error) {
    console.log('loadSyncLogList error', error)
    // yield call(unauthorizeUser(error));
    yield put(action.loadSyncLogListError(error));
  }
}

export function* watchLoadSyncLogList() {
  yield takeEvery(action.SYNC_LOG_GET_LIST, loadSyncLogList);
}

export default function* rootSaga() {
  yield all([
    fork(watchLoadSyncLogList),
  ]);
}
